import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const T = {
  bg:'#07080c', bg2:'#0c0f18', surf:'#161c2a',
  border:'rgba(255,255,255,.07)',
  white:'#dce6fa', muted:'rgba(220,230,250,.45)', dim:'rgba(220,230,250,.22)',
  cyan:'#00c8f0', blue:'#4d8fff', green:'#2ecc71', red:'#e74c3c',
  sans:'"Syne","DM Sans",system-ui,sans-serif',
};

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function ForgotPasswordPage() {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/api/auth/forgot-password/`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const d = await res.json();
        throw new Error(d.error || 'Request failed');
      }
      setSent(true);
    } catch(err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing:border-box; margin:0; padding:0; }
        input::placeholder { color:${T.dim}; }
        input:focus { border-color:rgba(0,200,240,.5)!important; outline:none; }
        @keyframes spin { to{transform:rotate(360deg)} }
      `}</style>

      <div style={{
        minHeight:'100vh', background:T.bg, display:'flex',
        alignItems:'center', justifyContent:'center', padding:'24px',
        fontFamily:T.sans,
      }}>
        <div style={{ width:'100%', maxWidth:420 }}>

          {/* Logo */}
          <div style={{ textAlign:'center', marginBottom:28 }}>
            <Link to="/" style={{ textDecoration:'none' }}>
              <div style={{ fontSize:22, fontWeight:900, color:T.white, letterSpacing:'-.02em' }}>
                Tylent<span style={{ color:T.cyan }}>ed</span>
              </div>
            </Link>
          </div>

          <div style={{
            background:'rgba(255,255,255,.025)', border:`1px solid ${T.border}`,
            borderRadius:16, padding:'28px 26px',
          }}>
            {sent ? (
              // Success state
              <div style={{ textAlign:'center', padding:'8px 0' }}>
                <div style={{ fontSize:36, marginBottom:14 }}>📧</div>
                <h2 style={{ fontSize:18, fontWeight:800, color:T.white, marginBottom:8 }}>
                  Check your email
                </h2>
                <p style={{ fontSize:13.5, color:T.muted, lineHeight:1.7, marginBottom:20 }}>
                  If an account exists for <strong style={{ color:T.white }}>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
                </p>
                <p style={{ fontSize:12, color:T.dim, marginBottom:18 }}>
                  The link expires in 1 hour.
                </p>
                <button onClick={() => setSent(false)} style={{
                  padding:'8px 18px', borderRadius:7, border:`1px solid ${T.border}`,
                  background:'transparent', color:T.muted, fontSize:13,
                  fontFamily:T.sans, cursor:'pointer', marginRight:8,
                }}>Try again</button>
                <Link to="/login" style={{
                  padding:'8px 18px', borderRadius:7, border:`1px solid ${T.cyan}50`,
                  background:`${T.cyan}15`, color:T.cyan, fontSize:13, fontFamily:T.sans,
                  textDecoration:'none', display:'inline-block',
                }}>Back to sign in</Link>
              </div>
            ) : (
              // Form state
              <>
                <h2 style={{ fontSize:18, fontWeight:800, color:T.white, marginBottom:6 }}>
                  Forgot your password?
                </h2>
                <p style={{ fontSize:13, color:T.muted, marginBottom:22, lineHeight:1.6 }}>
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                <form onSubmit={handleSubmit}>
                  <label style={{ fontSize:12, color:T.muted, display:'block', marginBottom:5 }}>
                    Email address
                  </label>
                  <input
                    type="email" value={email} onChange={e=>setEmail(e.target.value)}
                    placeholder="you@example.com" required
                    style={{
                      width:'100%', padding:'11px 14px', marginBottom:14,
                      background:T.bg2, border:`1px solid ${T.border}`,
                      borderRadius:8, color:T.white, fontSize:14, fontFamily:T.sans, outline:'none',
                      transition:'border-color .15s', boxSizing:'border-box',
                    }}
                  />

                  {error && (
                    <div style={{
                      padding:'9px 13px', marginBottom:14, borderRadius:7,
                      background:`${T.red}12`, border:`1px solid ${T.red}40`,
                      fontSize:12.5, color:T.red,
                    }}>{error}</div>
                  )}

                  <button type="submit" disabled={loading} style={{
                    width:'100%', padding:'12px', border:'none', borderRadius:8,
                    background: loading ? `${T.cyan}40` : `linear-gradient(135deg,${T.cyan},${T.blue})`,
                    color:'#07080c', fontSize:14, fontWeight:700, fontFamily:T.sans,
                    cursor: loading ? 'default' : 'pointer',
                    display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                  }}>
                    {loading && <div style={{ width:14, height:14, borderRadius:'50%', border:'2px solid rgba(0,0,0,.3)', borderTopColor:'#07080c', animation:'spin .65s linear infinite' }}/>}
                    {loading ? 'Sending…' : 'Send reset link'}
                  </button>
                </form>

                <p style={{ textAlign:'center', marginTop:16, fontSize:13, color:T.muted }}>
                  Remember your password?{' '}
                  <Link to="/login" style={{ color:T.cyan, textDecoration:'none' }}>Sign in →</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
